<template>
  <div :class="{ 'item-container': direction === 'horizontal' }">
    <div class="lbl" :class="{ lblsm: direction == 'vertical'}">
      <span>{{ header }}</span>
      <span v-if="toolTipIconShow" 
            v-b-tooltip.right.nofade="toolTipDelay" 
            :title="toolTipText" 
            class="info-icon-tooltip">
        <font-awesome-icon :icon="['fas', 'info-circle']" />
      </span>
    </div>
                            
    <div class="opt-tree">
      <b-form-radio-group v-if="!showIcons"
                          v-model="selected"
                          :options="options"
                          button-variant="outline-primary"
                          :size="size"
                          class="radiobuttons"
                          name="radio-btn-outline"
                          buttons>
      </b-form-radio-group>

      <b-form-radio-group v-else 
                          buttons 
                          v-model="selected"
                          button-variant="outline-primary"
                          :size="size"
                          class="radiobuttons"
                          name="radio-btn-outline"> 
        <b-form-radio v-model="selected" 
                      value="bmw">
          <bmw-logo class="logo-size" />
        </b-form-radio>
        <b-form-radio v-model="selected" 
                      value="mini">
          <mini-logo class="logo-size" />
        </b-form-radio>
      </b-form-radio-group>
    </div>
  </div>
</template>

<script>
import EventBus from "@/services/EventBus.js";
import BmwLogo from "@/components/Dashboard-bmw/Logo/BMW.vue";
import MiniLogo from "@/components/Dashboard-bmw/Logo/MINI.vue";

export default {
  props: {
    header: String,
    selectedEventName: String,
    itemData: Object,
    size: { type: String, default: "md" },
    direction: { type: String, default: "horizontal" },
    showIcons: Boolean, 
    toolTipIconShow: { type: Boolean, default: false }, // Show info Icon right next to header text
    toolTipDelay: { type: Object, default:  () => ({ delay: { "show": 500, "hide": 100 } }) },
    toolTipText: { type: String, default: 'Tooltiptext' }
  },

  components: {
    BmwLogo, MiniLogo
  },

  data() {
    return {
      selected: '',
      options: []
    };
  },

  watch: {
    selected: {
      immediate: true,
      handler (newVal, oldVal) {
        if (!_.isEmpty(newVal)) {
          EventBus.$emit(this.selectedEventName, newVal);
        }
      }
    },
    itemData: {
      immediate: true,
      handler(newVal, oldVal) {
        if (oldVal == newVal) return;
        this.options = newVal.options;
        this.selected = newVal.selected;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 
.logo-size {
  height: 22px;
  width: 36px;
}

.btn-group, .btn-group-vertical {
  padding-right: 4px;
  margin-top: 4px;   
  width: 100%;
}

.radiobuttons {
  min-width: 9.5rem;
} 

.item-container {
  display: grid;
  grid-template-columns: auto auto;
  margin: auto;
  margin-bottom: 0rem;
}

.lbl {
  text-align: left;
  vertical-align: left;
  min-width: 7rem;
  line-height: 3.3em;
  margin-bottom: 0rem;
}
.lblsm {
  line-height: unset !important;
}
.opt-tree {
  vertical-align: middle;
  margin-bottom: 0rem;
}
</style>